import {
  Menu,
  MenuButton,
  Button,
  MenuList,
  MenuItem,
  MenuDivider,
} from '@chakra-ui/react';
import { productApprovalsApi } from '@texas/api/endpoints/productApprovalsApi';
import {
  saveBlobAsFile,
  excelExportFileName,
  exportPrefixes,
} from '@texas/utils/helpers/filesHelper';
import { Icons, defaultIconSize } from '../Icons';
import { useTranslation } from 'react-i18next';

export function ProductApprovalMenu({
  selectedIds,
  allIds,
}: {
  selectedIds: number[];
  allIds: number[];
}) {
  const { t } = useTranslation();
  return (
    <Menu>
      <MenuButton ml="auto" as={Button} rightIcon={<Icons.ChevronDown />}>
        {t('general.actions')}
      </MenuButton>
      <MenuList>
        <MenuItem
          as="a"
          href={productApprovalsApi.downloadMultipleSupplierProductApprovals(
            selectedIds,
          )}
          target="_blank"
          download={true}
          isDisabled={selectedIds.length == 0}
          icon={<Icons.FilePdfBox boxSize={defaultIconSize} />}
        >
          {t('productApproval.downloadSpaMultiple')}
        </MenuItem>
        <MenuDivider />
        <MenuItem
          as="a"
          href={productApprovalsApi.downloadMultipleCustomerProductApprovals(
            false,
            selectedIds,
          )}
          target="_blank"
          download={true}
          isDisabled={selectedIds.length == 0}
          icon={<Icons.FilePdfBox boxSize={defaultIconSize} />}
        >
          {t('productApproval.downloadPaIncludeMaterialsMultiple')}
        </MenuItem>
        <MenuItem
          as="a"
          href={productApprovalsApi.downloadMultipleCustomerProductApprovals(
            true,
            selectedIds,
          )}
          target="_blank"
          download={true}
          isDisabled={selectedIds.length == 0}
          icon={<Icons.FilePdfBox boxSize={defaultIconSize} />}
        >
          {t('productApproval.downloadPaExcludeMaterialsMultiple')}
        </MenuItem>
        <MenuDivider />
        <MenuItem
          onClick={async () => {
            const response = await productApprovalsApi.downloadExcel({
              productApprovalIds: selectedIds,
            });

            if (response.hasError) return;

            saveBlobAsFile(
              response.data,
              excelExportFileName(exportPrefixes.productApprovals),
            );
          }}
          isDisabled={selectedIds.length == 0}
          icon={<Icons.FileExcelBox boxSize={defaultIconSize} />}
        >
          {t('general.exportExcelSelected')}
        </MenuItem>
        <MenuItem
          onClick={async () => {
            const response = await productApprovalsApi.downloadExcel({
              productApprovalIds: allIds,
            });

            if (response.hasError) return;

            saveBlobAsFile(
              response.data,
              excelExportFileName(exportPrefixes.productApprovals),
            );
          }}
          isDisabled={allIds.length == 0}
          icon={<Icons.FileExcelBox boxSize={defaultIconSize} />}
        >
          {t('general.exportExcel')}
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
